import { FC, ReactNode } from 'react'

import Mascot from 'assets/image/investors/zeroDeposit.svg?url'
import { useTranslation } from 'react-i18next'
import { PathsFund } from 'routesFunds/paths'
import { PathsInvestors } from 'routesInvestors/paths'

import s from './s.module.scss'

type Props = {
  homeHref?: string
  message?: ReactNode
  title?: string
}

const app = import.meta.env.VITE_APP

const Error: FC<Props> = ({ homeHref, message, title }) => {
  const { t } = useTranslation()

  const isInvestor = app === 'investors'
  const defaultHomeHref = `/${isInvestor ? PathsInvestors.Marketplace : PathsFund.Login}`

  return (
    <div className={s.wrapperError}>
      <div className={s.error}>
        <img alt="mascot" src={Mascot} />
        <h1>{title || t('error-title')}</h1>
        <p>
          {message || (
            <>
              This might be a temporary issue. Try refreshing the page or return to the
              <a href={homeHref || defaultHomeHref}>home page</a>.
            </>
          )}
        </p>
      </div>
    </div>
  )
}
export default Error
